export default "__VITE_ASSET__6f3c73c7__"